<div class="grid place-items-center">
  <input
    type="radio"
    class="border-theme-primary-blue peer col-start-1 row-start-1 aspect-square w-5 cursor-pointer appearance-none rounded-full border-2"
    [ngClass]="{
      'border-red-400': invalid(),
      'border-theme-primary-blue': !invalid(),
    }"
    [formControl]="control()"
    [id]="id()"
    [name]="name()"
    [value]="value()" />
  <div
    class="peer-checked:bg-theme-primary-blue pointer-events-none col-start-1 row-start-1 aspect-square w-2.5 rounded-full"></div>
</div>
